// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"N2-z"};